/*
 * Marketing-site destinations the dashboard links out to.
 *
 * Self-serve sign-up is handled on the marketing site, not in this app — the
 * "Get Movebooth" affordance and the /sign-up route both forward here so new
 * customers land on the product page rather than an in-app pricing table.
 */
export const MARKETING_SIGNUP_URL =
  'https://www.movebooth.com/products/ipad-photo-booth-app';

// The plans page (/start's lapsed screen, and the limited dashboard's "Rent a booth").
export const MARKETING_PRICING_URL = 'https://www.movebooth.com/pricing';
export const MARKETING_RENT_URL = 'https://www.movebooth.com/rent';
export const MARKETING_HOME_URL = 'https://www.movebooth.com/';

// The live Terms of Service and Privacy Policy; the in-app /terms route forwards here.
export const MARKETING_TERMS_URL = 'https://www.movebooth.com/terms';
